module.exports = __webpack_public_path__ + "img/drachenmakifrontalweiss.f27f9044.jpg";